import { ClusterCreate_clusterCreate_errors } from "@saleor/cluster/types/ClusterCreate";
import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import PageBackNavigation from "@saleor/components/PageBackNavigation";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { StoreTypeEnum } from "@saleor/types/globalTypes";
import { useCreateClusterValidation } from "@saleor/utils/validators/cluster";
import { hasNoError } from "@saleor/utils/validators/sales";
import React from "react";
import { useIntl } from "react-intl";

import ClusterContent from "../ClusterContent/ClusterContent";
import ClusterInfo from "../ClusterInfo";

export interface ClusterFormData {
  lowerPrepTimeDays: string;
  lowerPrepTimeHours: string;
  lowerPrepTimeMins: string;
  name: string;
  productType: string;
  upperPrepTimeDays: string;
  upperPrepTimeHours: string;
  upperPrepTimeMins: string;
}

export interface ClusterCreatePageProps {
  errors: ClusterCreate_clusterCreate_errors[];
  onBack: () => void;
  disabled: boolean;
  saveButtonBarState: ConfirmButtonTransitionState;
  onSubmit(data: ClusterFormData);
}

const ClusterCreatePage: React.FC<ClusterCreatePageProps> = props => {
  const { onBack, disabled, saveButtonBarState, onSubmit, errors } = props;
  const intl = useIntl();

  const [validator, setValidator] = React.useState({
    lowerPrepTimeDays: null,
    lowerPrepTimeHours: null,
    lowerPrepTimeMins: null,
    name: null,
    productType: null,
    upperPrepTimeDays: null,
    upperPrepTimeHours: null,
    upperPrepTimeMins: null
  });

  const initialForm: ClusterFormData = {
    lowerPrepTimeDays: "0",
    lowerPrepTimeHours: "0",
    lowerPrepTimeMins: "0",
    name: "",
    productType: StoreTypeEnum.FOOD_AND_BEVERAGES,
    upperPrepTimeDays: "0",
    upperPrepTimeHours: "0",
    upperPrepTimeMins: "0"
  };

  const handleSubmit = event => {
    const validate = useCreateClusterValidation(event);
    setValidator(validate);
    if (hasNoError(validate)) {
      onSubmit(event);
    }
  };

  const breadcrumbDirectory = [
    {
      name: "Clusters",
      url: "/clusters"
    },
    {
      name: "Create Cluster"
    }
  ];

  return (
    <Form initial={initialForm} onSubmit={handleSubmit}>
      {({ data, change, hasChanged, submit }) => (
        <Container>
          <PageBreadcrumbNavigation items={breadcrumbDirectory} />
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}
          >
            <PageBackNavigation onBack={onBack} />
            <PageHeader
              title={intl.formatMessage({
                defaultMessage: "Create Cluster",
                description: "page header"
              })}
            />
          </div>
          <div>
            <ClusterInfo
              errors={errors}
              data={data}
              onChange={change}
              disabled={false}
              localError={validator}
            />
            <CardSpacer />
            <ClusterContent
              data={data}
              errors={errors}
              onChange={change}
              disabled={false}
              localError={validator}
            />
          </div>
          <SaveButtonBar
            disabled={disabled || !hasChanged}
            onCancel={onBack}
            onSave={submit}
            state={saveButtonBarState}
          />
        </Container>
      )}
    </Form>
  );
};

export default ClusterCreatePage;
